import React, { Component } from 'react';

import AdminAPI from './AdminAPI';


import { apiPut, apiPost, apiGet, apiDelete } from '../../Api';
import ItemTypeList from './Admin_ItemTypes_List';
import ItemTypeDetail from './Admin_ItemTypes_Detail';

export default class Admin_ItemTypes extends Component {


  constructor(props) {
    super(props);
    this.state = {
      itemtypes: [], // Load this from your backend
      items: [],
      stats: [],
      creatingNewItemType: false,
      selectedItemTypeId: ""
    }
  }




  componentDidMount = async () => {
    this.setState({ itemtypes: await AdminAPI.getItemTypes() });
    this.setState({ items: await AdminAPI.getItems() || [] });
    this.setState({ stats: await AdminAPI.getStats() });
  }

  handleSelectItemType = (itemtype) => {

    this.setState({
      selectedItemType: itemtype,
      creatingNewItemType: false,
      selectedItemTypeId: itemtype.id,
    });

  };

  handleNewItemType = () => {
    this.setState({
      creatingNewItemType: true,
      selectedItemType: {},
      selectedItemTypeId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedItemType: null,
      creatingNewItemType: false,
    });
  };

  handleUpdate = async (itemtype) => {
    const response = await apiPut("/itemtype", JSON.stringify(itemtype));
    if (response.ok) {
      this.setState({ itemtypes: await AdminAPI.getItemTypes() });
      this.setState({ selectedItemTypeId: null });
    }
  };

  handleDelete = async (itemtype) => {
    // Send delete request to your backend
    const response = await apiDelete("/itemtype/" + itemtype.id);
    if (response.ok) {
      this.setState({ itemtypes: await AdminAPI.getItemTypes() });
      this.setState({ selectedItemTypeId: null });
    }
  };

  handleCreate = async (itemtype) => {
    // Send delete request to your backend
    const response = await apiPost("/itemtype", JSON.stringify(itemtype));

    if (response.ok) {

      this.setState({ itemtypes: await AdminAPI.getItemTypes() });
      this.setState({ selectedItemTypeId: null });
    }
    else {
      window.alert(response.text());
    }
  };

  handleSearch = (searchQuery) => {
    // Filter the itemtypes based on search query
  };



  // findSelectedItemType = () => {

  //   return this.state.itemtypes.find((c) => c.id === this.state.selectedItemTypeId);

  // }



  render() {
    const { itemtypes, creatingNewItemType } = this.state;

    return (
      <div className="admin-settingspage">
        <ItemTypeList
          itemtypes={itemtypes}
          onSelectItemType={this.handleSelectItemType}
          onSearch={this.handleSearch}
          onNewItemType={this.handleNewItemType}
        />



        <ItemTypeDetail
          items={this.state.items}
          stats={this.state.stats}
          creatingNewItemType={creatingNewItemType}
          itemtypeId={this.state.selectedItemTypeId}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
        />

      </div>
    );
  }
}
